export default {"src":"/_next/static/media/denver-logo.8ac61178.svg","height":70,"width":300,"blurWidth":0,"blurHeight":0};